/** @format */

import di from "dependeny-injection";
import container from "./tags/register-route-base.riot";
import EdilentWorkerApi from "@model/api.js";
import linkOuter from "@tags/parts/link-outer.riot";

di.riot.mount("binding");
di.riot.mount("pagination-tag");
di.riot.register("link-outer", linkOuter);

di.set("createApi", () => new EdilentWorkerApi("register"));

const mtContainer = di.riot.component(container);
mtContainer(document.getElementById("root"));
